import React, { useState, useEffect, useContext } from "react";
import { ShimmerTable } from "react-shimmer-effects";
import moment from "moment";
import { Table, Button } from "react-bootstrap";
import { useNavigate, Link, useLocation } from "react-router-dom";
import schoolApi from "../../api/schoolApi";
import {
  DatatableWrapper,
  Pagination,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SessionContext } from "../SessionProvider";


function Studentadmission({ studentid, admissionId }) {
  console.log("studentid->", studentid, "admissionId->", admissionId);
  const [admissionBody, setAdmissionBody] = useState([]);
  const navigate = useNavigate(); //navigation
  useEffect(() => {
    setAdmissionBody([]);
    fetchAdmission();
  }, [studentid, admissionId]);
  const { selectedSessionId, setSelectedSessionId, currentSessionId } = useContext(SessionContext);
  const [isCurrentSession,setIsCurrentSession] = useState();

  useEffect(() => {
    async function init() {
      try {
        if (currentSessionId !== null && currentSessionId !== undefined) {
          setIsCurrentSession(selectedSessionId === currentSessionId);
        }
      } catch (error) {
        console.log('error=>', error);
      }
    }
    init();
  }, [selectedSessionId,isCurrentSession]);

  const fetchAdmission = async () => {
    let studenId = studentid;
    if (studenId !== null) {
      try {
        console.log("student@@@@@@@@@@@@>>",studenId)
        const result = await schoolApi.fetchAdmissionByStudentId(studenId);
        console.log("result->", result);

        if (result.success) {
          const withregistrationidstudetn = result.studentAddmision.filter(
            (item) => item.registration_id !== null
          );

          if (result.studentAddmision.length === 0) {
            setAdmissionBody([]);
            return;
          }

          let processedAdmissions = [];
          for (let item of result.studentAddmision) {
            let processedItem = { ...item };
            processedItem.dateofaddmission = moment(
              processedItem.createddate || processedItem.dateofaddmission,
              "YYYY-MM-DD"
            ).format("DD-MM-YYYY");
            
            if (!processedItem.registration_id && withregistrationidstudetn.length > 0) {
              processedItem.registration_id = withregistrationidstudetn[0]?.registration_id;
            }
            
            try {
              const instResult = await schoolApi.fetchStudentFeeInstallments(processedItem.id);
              if (instResult?.success && instResult?.result) {
                const anyPaid = instResult.result.some(res => res.status !== "pending" || Number(res?.deposit_amount) > 0);
                processedItem.has_paid_installments = anyPaid;
              }
            } catch (e) {
              console.log(e);
            }
            processedAdmissions.push(processedItem);
          }
          
          processedAdmissions.sort((a, b) => a.id === admissionId ? -1 : b.id === admissionId ? 1 : 0);
          setAdmissionBody([processedAdmissions]);
        }
      } catch (error) {
        toast.error(error?.response?.data?.message);
      }
    }
  };

  const location = useLocation();
  const headerAdd = [
    {
      title: "Regisration Id",
      prop: "registration_id",
      isFilterable: true,
    },
    {
      title: "Student Name",
      prop: "studentname",
      isFilterable: true,
    },
    {
      title: "Date of Admission",
      prop: "dateofaddmission",
      isFilterable: true,
    },
    {
      title: "Current Class",
      prop: "current_class",
      isFilterable: true,
    },
    {
      title: "Fee Installment Type",
      prop: "fee_master_type",
      isFilterable: true,
    },
    {
      title: "Status",
      prop: "student_admission_status",
      isFilterable: true,
      
    },
    {
      title: (
        <div className="d-flex justify-content-between align-items-center">
          <span>Action</span>
          {admissionBody &&
            admissionBody.flat().length > 0 &&
            admissionBody.flat()[0]?.student_admission_status === "inactive" &&
            Number(admissionBody.flat()[0]?.paid_installments_count || 0) === 0 &&
            !admissionBody.flat()[0]?.has_paid_installments && (
              <Button
                className="btn-sm mx-1 edit-button"
                variant="primary"
                disabled={isCurrentSession === false ? true : false}
                onClick={(e) => {
                  e.stopPropagation();
                  editStudentAddmisionEditable(admissionBody.flat()[0]);
                }}
                title="Change Class Admission"
              >
                <i className="fa-solid fa-user-pen"></i>
              </Button>
            )}
        </div>
      ),
      prop: "",
      isFilterable: false,
      cell: (row) => {
        return (
          <>
            <Button
              className="btn-sm mx-2 edit-button"
              variant=""
              disabled={isCurrentSession === false ? true : row.student_admission_status === "inactive"}
              onClick={() => editStudentAddmision(row)}
            >
              <i className="fa-regular fa-pen-to-square"></i>
            </Button>
          </>
        );
      },
    },
  ];
  const editStudentAddmision = (row) => {
    row.student_addmission_id = row.id;
    navigate(`/studentaddmissions/${row.id}/e`, {
      state: row,
    });
  };
  const editStudentAddmisionEditable = (row) => {
    row.student_addmission_id = row.id;
    navigate(`/student/${row.id}/e`, {
      state: {
        ...(location.state || {}),
        student_info: {
          ...(location.state?.student_info || {}),
          ...row,
        },
        editable: true,
      },
    });
  };
  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {admissionBody ? (
        admissionBody.length > 0 ? (
          <DatatableWrapper body={admissionBody.flat()} headers={headerAdd}>
            <Table striped className="data-table custom-table-subject-list">
              <TableHeader />
              <TableBody />
            </Table>
            <Pagination />
          </DatatableWrapper>
        ) : (
          <div>
            <DatatableWrapper body={admissionBody.flat()} headers={headerAdd}>
              <Table striped className="data-table custom-table-subject-list">
                <TableHeader />
                <TableBody>
                  <tr>
                    <td colSpan={headerAdd.length} className="text-center">
                      No Records Found!!!
                    </td>
                  </tr>
                </TableBody>
              </Table>
              <Pagination />
            </DatatableWrapper>
          </div>
        )
      ) : (
        <ShimmerTable row={10} col={8} />
      )}
    </div>
  );
}

export default Studentadmission;
